import React from "react"
import { Popover } from "antd"
import IconQuestions from "../Icon/IconQuestions"

const TooltipComponents = ({ name }) => {
  const segmentsTooltip = () => {
    return (
      <div style={{ fontSize: "13px" }}>
        La <strong>segmentación</strong> elegida será utilizada para{" "}
        <strong>calcular y agrupar los resultados</strong>
        <br />
        mostrados en Reportes.
        <br />
        <ul style={{ listStylePosition: "outside", marginLeft: "16px" }}>
          <li>
            <strong>Divisiones:</strong> Las respuestas de los colaboradores
            serán segmentadas en base a la
            <br />
            división a la cual estén asignados. Los resultados de una división
            contemplarán
            <br />
            todas las respuestas de las subdivisiones de la misma, a lo largo de
            toda su línea
            <br />
            jerárquica.
          </li>
          <li>
            <strong>Líderes:</strong> Las respuestas de los colaboradores serán
            segmentadas en base al líder
            <br /> directo que tienen asignado. Los resultados de un líder
            contemplan únicamente
            <br /> las respuestas de sus reportes directos.
          </li>
        </ul>
      </div>
    )
  }

  const calculationCriteriaTooltip = () => {
    return (
      <div style={{ fontSize: "13px" }}>
        El criterio de <strong>cálculo elegido</strong> será el que se utilice
        para <strong>calcular los resultados</strong> a<br />
        mostrar en los <strong>Reportes</strong>
        de tu medición.
        <br />
        <ul style={{ listStylePosition: "outside", marginLeft: "16px" }}>
          <li>
            <strong>Top Two Box:</strong> porcentaje (%) de personas que
            respondieron 4 o 5 a las distintas
            <br /> preguntas que componen el cuestionario.
          </li>
          <li>
            <strong>Promedio simple:</strong> promedio de los valores de las
            respuestas a las preguntas que
            <br /> componen el cuestionario.
          </li>
        </ul>
      </div>
    )
  }

  const anonymityTooltip = () => {
    return (
      <div style={{ fontSize: "13px" }}>
        El <strong>anonimato</strong> configurado será la{" "}
        <strong>cantidad mínima</strong> de personas que deben
        <br />
        contestar la encuesta para mostrar los resultados en cada posible
        segmentación.
      </div>
    )
  }

  const measureInProgressTooltip = () => {
    return (
      <div style={{ fontSize: "13px" }}>
        No es posible editar el criterio de cálculo de un indicador que está
        <br />
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        siendo utilizado en una medición "En cursor" o "Finalizada".
      </div>
    )
  }

  const response = {
    segments: segmentsTooltip(),
    calculationCriteria: calculationCriteriaTooltip(),
    anonymity: anonymityTooltip(),
    measureInProgress: measureInProgressTooltip(),
  }

  return (
    <span>
      <Popover content={response[name]} placement="rightBottom">
        <IconQuestions />
      </Popover>
    </span>
  )
}

TooltipComponents.propTypes = {}

export default TooltipComponents
